// repositories/product-supplier.js
import useSWR from "swr"
import axios from "axios"

const fetcher = (url) => axios.get(url).then((res) => res.data)

export default function useProductSupplierRepositories(params = {}) {
    const query = new URLSearchParams()

    Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
            query.append(key, value)
        }
    })

    const baseUrl = `${process.env.REACT_APP_INVENTORY_API_URL}/product/supplier`
    const url = `${baseUrl}?${query.toString()}`

    const { data, error, mutate, isValidating } = useSWR(url, fetcher)

    return {
        data,
        error,
        mutate,
        isLoading: !error && !data && isValidating,
    }
}
